import React from 'react';

import { Header } from "./layouts/Header";
import { Jumbotron } from "./layouts/Jumbotron";
import { HowExchangeWorks } from "./layouts/HowExchangeWorks";
import { FAQ } from "./layouts/FAQ";
import {PrivacyPolicy} from "./layouts/PrivacyPolicy";


const App = () => {
  return (
    <div className="wrapper">
      <div className="header-block">
        <div className="container">
          <Header/>
          <Jumbotron/>
        </div>
      </div>
      <div className="how-exchange-works__wrapper">
        <div className="container">
          <HowExchangeWorks/>
        </div>
      </div>
      <div className="faq-block">
        <div className="container">
          <FAQ/>
        </div>
      </div>
        <div className="faq-block">
            <div className="container">
                <PrivacyPolicy />
            </div>
        </div>
    </div>
  );
};

export default App;
